import { $location } from '../../y/location';
import { $fn } from '../../y/fn';
import { $el } from '../elements';
import { UIClassesSpec } from '../types';

export namespace $spotify {
    const link_regex = /^https.*spotify\.com.*$/;

    export function isValidLink(link: string) {
        return link_regex.test(link);
    }

    export function player(url: string, classes?: UIClassesSpec) {
        const path = $location.getURL(url).pathname.split('/').filter($fn.ID).join('%3A');
        const iframe = $el.IFRAME('https://open.spotify.com/embed?uri=spotify%3A' + path, classes);
        iframe.setAttribute('allow', 'encrypted-media');
        return iframe;
    }
}